import { Container, Root, Text } from "@react-three/uikit";
import { Button } from "../components/default/button";

export const MissingPartDisplay = () => {
  return (
    <Root>
      <Container
        flexGrow={1}
        backgroundOpacity={0.5}
        hover={{ backgroundOpacity: 1 }}
        backgroundColor="red"
      >
        <Button>
          <Text>Missing Part</Text>
        </Button>
      </Container>
    </Root>
  );
};
